export const getServiceDisplayName = (appointment) => (
  appointment?.service?.name || appointment?.serviceName || 'Service'
);

export const getStaffDisplayName = (appointment) => {
  const raw = appointment?.employeeName
    || appointment?.employee?.assignedEmployeeName
    || appointment?.employee?.name
    || '';
  const trimmed = String(raw).trim();
  if (!trimmed) return 'Staff';
  const [first] = trimmed.split(/\s+/);
  return first || 'Staff';
};

/** Maps raw status strings to keys understood by `getStatusColor` in `utils/appointmentUtils`. */
export const normalizeStatusForColorLookup = (raw) => {
  const s = String(raw || '').toLowerCase().trim();
  if (!s) return '';
  if (s === 'no show' || s === 'no_show' || s === 'no-show' || s === 'noshow') return 'no show';
  return s.replace(/[\s-]+/g, '_');
};

export const formatAppointmentStatusLabel = (raw) => {
  if (!raw) return '';
  return String(raw)
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
};

export const splitCurrentAndPastAppointments = (appointments) => {
  const now = new Date();
  const current = [];
  const past = [];

  appointments.forEach((apt) => {
    if (apt.isArchived) {
      past.push(apt);
      return;
    }
    const isFuture = apt.startTime >= now;
    const isNotCancelled = apt.status !== 'cancelled';
    const isNotCompleted = apt.status !== 'completed';
    if (isFuture && isNotCancelled && isNotCompleted) {
      current.push(apt);
    } else {
      past.push(apt);
    }
  });

  return { currentAppointments: current, pastAppointments: past };
};
